import * as yup from "yup";

export const WSIBAssociationSetupValidationSchema = yup.object().shape({
  provinceId: yup.string().required("Province is required"),
  codeLabel: yup.string().required("Code is required"),
  categoryLabel: yup.string().required("Category is required"),
  classLabel: yup.string().required("Class is required"),
  effectiveDate: yup.string().required("Effective Date is required"),
});
